<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Jobs</v-tab>
            <v-tab>Personal Information</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card
                    class="mx-auto"
                    flat
                    :loading="loading"
                    loader-height="10"
                    tile
                >
                    <v-toolbar
                    color="#0c477c"
                    dark
                    flat
                    height="40"
                    >
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="jobs-count" >
                            {{ total + ' Jobs Found.' }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list two-line tile flat class="py-0">
                        <template v-for="(job, index) in jobs">
                            <v-list-item
                            :key="`job-${index}`"
                            :value="job.id"                 
                            >
                                <template>
                                    <v-list-item-content @click.stop="openJob(job.id)">
                                        <v-list-item-title v-html="job.customer.street_address+ ', ' + job.customer.city + ', ' + job.customer.state + ' ' + job.customer.zip"></v-list-item-title>
                                        <v-list-item-subtitle>{{ job.customer.title }}</v-list-item-subtitle>
                                        <v-list-item-subtitle>{{ job.job_time | moment('MMMM Do YYYY, h:mm:ss a') }}</v-list-item-subtitle>
                                        <div>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            :color="getColor(job.status)"
                                            text-color="white"
                                            small
                                            label
                                            >
                                            {{ job.status | capitalize }}
                                            </v-chip>
                                        </div>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-list-item-icon class="ma-0 mb-1">
                                            <v-btn small tile class="mr-1" elevation="0" color="#0298c6" dark @click.stop="googleLink(job.customer)">
                                                <v-icon dark>mdi-map-marker</v-icon>
                                            </v-btn>

                                            <v-btn small tile class="mr-1" color="#003a6f" elevation="0" dark @click.stop="dial(job.customer.phone)">
                                                <v-icon dark>mdi-phone</v-icon>
                                            </v-btn>
                                        </v-list-item-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                            <v-divider
                            :key="`dv-${index}`"
                            ></v-divider>
                        </template>
                        <v-list-item v-if="pagination.total > 1">
                            <v-list-item-content>
                                <v-pagination
                                    v-model="pagination.current"
                                    :length="pagination.total"
                                    @input="onPageChange"
                                    :total-visible="totalVisible"
                                ></v-pagination>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                                                <v-text-field
                                                v-model="form.name"
                                                :error-messages="errors"
                                                label="Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                <v-text-field
                                                v-model="form.phone"
                                                :error-messages="errors"
                                                label="Phone"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                           <ValidationProvider v-slot="{ errors }" name="Password" vid="password">
                                                <v-text-field
                                                    ref="password"
                                                    type="password"
                                                    v-model="form.password"
                                                    :error-messages="errors"
                                                    label="Password"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Confirm Password" rules="confirmed:password">
                                                <v-text-field
                                                    ref="password_confirmation"
                                                    type="password"
                                                    v-model="form.password_confirmation"
                                                    :error-messages="errors"
                                                    label="Confirm Password"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="4 Digit Code" rules="max:4">
                                                <v-text-field
                                                    ref="logincode"
                                                    type="logincode"
                                                    v-model="form.logincode"
                                                    :error-messages="errors"
                                                    label="Login Code"
                                                ></v-text-field>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>   
                        <v-btn large min-width="50%" color="blue darken-1" text to="/dashboard">Cancel</v-btn>                     
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Update</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { required, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

extend('max', {
    ...max,
    message: '{_field_} must limit to 4 digits',
})


export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                logincode: '',
                role: 'cleaner'
            },
            loading: false,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
            jobs: [],
            pagination: {
                current: 1,
                total: 0
            },
            total: 0,
            totalVisible: 5,
            filter: {
                cleaner: "",
            },
        }
    },
    created() {
        this.getCleaner()
        this.getJobs()
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions({
            updateCleaner: 'data/updateUser',
        }),
        getJobs() {
            this.loading = true
            this.drawer = false
            this.$set(this.filter, 'cleaner', this.id)
            axios.get('admin/cleanerjobs/all?page=' + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.jobs = response.data.jobs.data
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        getCleaner() {
            if(this.id) {
                axios.get('admin/users/get?id=' + this.id)
                    .then((response) => {
                        this.form = response.data
                        this.$nextTick()
                    })
            }
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateCleaner(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: '/cleaners' })
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        openJob(id) {
            this.$router.push({ path: '/job/'+id })
        }
    }
}
</script>

<style lang="sass" scoped>
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
</style>